export const Role = {
  EnvironmentsAdmin: 'EnvironmentsAdmin',
  CatalogsAdmin: 'CatalogsAdmin',
  FormsAdmin: 'FormsAdmin',
  NotificationsAdmin: 'NotificationsAdmin',
  DetailsReports: 'DetailsReports',
  TaxpayersAdmin: 'TaxpayersAdmin',
  PaymentsAdmin: 'PaymentsAdmin',
  TaxpayerReports: 'TaxpayerReports',
  TaxpayersApprover: 'TaxpayersApprover',
  TaxreturnReports: 'TaxreturnReports',
  TaxreturnApprover: 'TaxreturnApprover',
  UsersAdmin: 'UsersAdmin',
  SystemAuditor: 'SystemAuditor',
  ManagementReportAdmin: 'ManagementReportAdmin',
  TfaAdmin: 'TfaAdmin',
  AccountReports: 'AccountReports',
  CurrentAccountAdmin: 'CurrentAccountAdmin',
  DebtCollectionOfficer: 'DebtCollectionOfficer',
  DebtCollectionManager: 'DebtCollectionManager',
  DebtCollectionAnalyst: 'DebtCollectionAnalyst',
  AdminApplicationClient: 'AdminApplicationClient',
  NonComplianceAnalyst: 'NonComplianceAnalyst',
  TaxpayerCommunication: 'TaxpayerCommunication',
  CollectionStatistics: 'CollectionStatistics',
  ComplianceStatistics: 'ComplianceStatistics',
  DisbursementView: 'DisbursementView',
  DisbursementManage: 'DisbursementManage'
};
